import * as React from "react";
import { useState } from "react";
import { Box, Paper, Tab, Tabs, Typography } from "@material-ui/core";
import RetailersTab from "./RetailersTab";
import MidsTab from "./MidsTab";
import UnknownMidsTab from "./UnknownMidsTab";
import CampaignsTab from "./CampaignsTab";
import AuditTab from "./AuditTab";

const TABS = ["Retailers", "Merchant IDs", "Unknown MIDs", "Campaigns", "Audit log"];

const CloConfigDashboard: React.FC = () => {
  const [tab, setTab] = useState(0);
  return (
    <Box p={2}>
      <Typography variant="h5" gutterBottom>
        CLO · Campaign & Merchant Config
      </Typography>
      <Paper>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} indicatorColor="primary" textColor="primary" variant="scrollable">
          {TABS.map((label) => (
            <Tab key={label} label={label} />
          ))}
        </Tabs>
      </Paper>
      <Box mt={2}>
        {tab === 0 && <RetailersTab />}
        {tab === 1 && <MidsTab />}
        {tab === 2 && <UnknownMidsTab />}
        {tab === 3 && <CampaignsTab />}
        {tab === 4 && <AuditTab />}
      </Box>
    </Box>
  );
};

export default CloConfigDashboard;
